import { createHttpLink, split } from '@apollo/client';
import { getMainDefinition } from '@apollo/client/utilities';
import { fetch } from 'whatwg-fetch';

import { ORM_PRIMARY_GRAPHQL_URL, ORM_REPLICA_GRAPHQL_URL } from '../../config';

import { shouldReadFromHasuraPrimary } from './hasuraPrimaryReadWindow';

const hasuraPrimaryHttpLink = createHttpLink({ fetch, uri: ORM_PRIMARY_GRAPHQL_URL });
const hasuraReplicaHttpLink = createHttpLink({ fetch, uri: ORM_REPLICA_GRAPHQL_URL });

// Read queries go to the Hasura replica by default. Mutations always go to the primary.
// And reads are sent to the primary while a recent write's window is open,
// (or when an individual call sets context.hasuraTarget = 'primary').
export const hasuraRoutedHttpLink = split(
  (operation) => {
    const definition = getMainDefinition(operation.query);
    const isMutation = definition.kind === 'OperationDefinition' && definition.operation === 'mutation';

    const forcePrimary = (
      shouldReadFromHasuraPrimary() || operation.getContext().hasuraTarget === 'primary'
    );

    return isMutation || forcePrimary;
  },
  hasuraPrimaryHttpLink,
  hasuraReplicaHttpLink,
);
